'use client';

import { useSummitI18n } from '../../i18n/SummitI18nProvider';
import { cn, generateRdsId } from '../../lib/utils';

const SHEET_DRAG_HANDLE_RDS_ID = generateRdsId('sheet-drag-handle');

const sheetDragHandleInteractiveStyles = `
  r:absolute r:inset-x-0 r:top-0
  r:flex r:justify-center r:items-center
  r:py-4.5
  r:touch-none r:select-none
  r:cursor-grab r:active:cursor-grabbing
  r:bg-inherit
  r:z-nudge
`;

const sheetDragHandleSpacerStyles = `
  r:w-full r:self-stretch r:shrink-0
  r:py-4.5
  r:flex r:justify-center r:items-center
`;

const SheetDragHandle = () => {
  const { tCore } = useSummitI18n();

  return (
    <>
      <div
        className={cn(SHEET_DRAG_HANDLE_RDS_ID, sheetDragHandleInteractiveStyles)}
        role="group"
        aria-label={tCore('sheet.dragHandleAriaLabel')}
        data-rds-id={SHEET_DRAG_HANDLE_RDS_ID}
        data-sds-id="sheet-drag-handle"
      >
        <span
          className="r:block r:h-1 r:w-14 r:shrink-0 r:rounded-full r:bg-neutral-700"
          aria-hidden="true"
        />
      </div>
      <div
        className={sheetDragHandleSpacerStyles}
        aria-hidden="true"
        data-sds-id="sheet-drag-handle-spacer"
      >
        <span className="r:block r:h-1 r:w-14 r:shrink-0" />
      </div>
    </>
  );
};
SheetDragHandle.displayName = 'SheetDragHandle';

export { SheetDragHandle };
